module.exports = __webpack_public_path__ + "static/media/Slide47.4d453a26.JPG";